<template>
  <div class="search-result-container" :style="{top: top+'px', left: left+'px'}">
    <div class="no-result" v-if="!filteredContactList.length&&!filteredCompanyList.length">
      <div>
        <img src="@/assets/no-person.png" alt="" class="no-person">
        <div class="no-result-text">{{$t('home.NoSearchResut')}}</div>
      </div>
    </div>
    <div class="has-result" v-else>
      <Contact
        v-if="filteredContactList.length"
        v-slot="{contact}"
        :contactList="filteredContactList"
      >
        <UserAvatar style="width: 20px;height: 20px;margin-right: 12px"
                   :user-avatar="contact.avatar"/>
        <template v-if="!contact.searchType">
          <span>{{ contact.name }}</span>
        </template>
        <template v-else>
          <div class="mobile-container">
            <div class="name">{{ contact.name }}</div>
            <div class="mobile">{{ contact.mobile }}</div>
          </div>
        </template>
        <DeviceType :deviceType="contact.deviceType" :roomId="contact.roomId" style="font-size: 20px;" />
      </Contact>
      <Company
        v-if="filteredCompanyList.length"
        v-slot="{company}"
        :companyList="filteredCompanyList"
      >
        <svg-icon style="width: 20px;height: 20px;" class-name="org-icon" icon-class="org"/>
        {{ company.name }}
      </Company>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Contact from './Contact'
import Company from './Company'
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import { CACHE_KEY } from '@/utils/constant'
import { clone } from 'ramda'
import DeviceType from '@/components/business/DeviceType'
import { setOnlinerAttrs, onlineToTop } from '@/components/business/contact-company-search/utils'

const { mapState } = createNamespacedHelpers('collaborator')

function getUserFormNameOrPinyinOrPinyunInit(searchVal){
  function getPingyinInit(nameSpell) {
    return nameSpell?.split('|').map(item => item[0]).join('') ?? ''
  }
  return ({ name, nameSpell }) => (~name.toLowerCase().indexOf(searchVal) ||
  ~nameSpell.replace(/\|/g, '').toLowerCase().indexOf(searchVal) ||
  ~getPingyinInit(nameSpell).toLowerCase().indexOf(searchVal))
}

export default {
  name: 'contactCompanySearch',
  props: {
    searchVal: {
      type: String,
      default: '',
      required: true
    },
    top: {
      type: String,
      default: '146'
    },
  },
  components: {
    Contact,
    Company,
    UserAvatar,
    DeviceType
  },
  inject: ['getReactiveCollapsed'],
  computed: {
    ...mapState(['cropList', 'onlineUsers']),
    isPureNums() {
      const regexp = /^[0-9]*$/g
      return regexp.test(this.searchVal)
    },
    userList() {
      return (this.$ss.get(`${CACHE_KEY.user}_own`) || []).concat(this.$ss.get(`${CACHE_KEY.user}_ext`) || [])
    },
    filteredCompanyList() {
      const searchVal = this.searchVal.toLowerCase()
      return this.cropList.filter(getUserFormNameOrPinyinOrPinyunInit(searchVal))
    },
    filteredContactList() {
      const searchVal = this.searchVal.toLowerCase()
      const filterByName = this.userList.filter(getUserFormNameOrPinyinOrPinyunInit(searchVal)).map(item => (setOnlinerAttrs([...this.onlineUsers.values()], item)))
      let filterByMobile = []
      if (this.isPureNums) {
        filterByMobile = clone(this.userList.filter(el => ~el.mobile.indexOf(searchVal))).map(item => (setOnlinerAttrs([...this.onlineUsers.values()], item)))
        filterByMobile.forEach(el => {
          el.searchType = 'mobile'
        })
      }
      const union = filterByName.concat(filterByMobile)
      for (let i = 0; i < union.length; i++) {
        for (let j = i + 1; j < union.length; j++) {
          if (union[i].uid === union[j].uid) {
            union.splice(j, 1)
            j--
          }
        }
      }
      return onlineToTop(union)
    },
    left() {
      return this.reactiveCollapsed ? 80 : 160
    },
    reactiveCollapsed() {
      return this.getReactiveCollapsed()
    }
  }
}
</script>

<style scoped lang="less">
.search-result-container {
  position: absolute;
  left: 0;
  width: 344px;
  box-shadow: 0 10px 20px 0 rgba(62, 85, 132, 0.3);
  border-radius: 16px;
  border: 1px solid #EDEFF2;
  background-color: #fff;
  z-index: 10;
  transition: left .2s;

  .no-result {
    display: flex;
    height: 400px;
    align-items: center;
    text-align: center;

    & > div {
      margin: auto;

      .no-person {
        width: 162px;
        height: 114px;
      }

      .no-result-text {
        font-size: 16px;
        font-weight: 400;
        color: #999B9F;
      }
    }
  }

  .has-result {
    width: 100%;
    max-height: 528px;
    overflow: auto;
    border-radius: 16px;
    padding: 24px 0;
  }
}
</style>
